import templateScorecard from '../../../../Template/config/components/scorecard'
import metricsLabels from './MetricsLabels'
import scorecardView from './ScorecardView'
import trendChart from './Trendchart'

export default {
  ...templateScorecard,
  maxAdsLength: 300,
  maxNormLength: 300,
  sampleSizeMetric: 1,
  sampleSizeThreshold: 50,
  hideMetricWithMissingNorm: false,
  sortMetric: 1,
  calcFlags: {
    ad: {
      includeAllHistory: true,
      excludeProprietary: false
    },
    norm: {
      excludeNonNorm: true,
      includeAllHistory: false,
      excludeProprietary: true,
      minSampleSize: 0
    }
  },
  scorecardView,
  metricsLabels,
  trendChart
}



// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/components/scorecard/index.js